<template>
    <div :class="classes">
        <div v-if="question.type === 'multiple'" class="d-flex align-items-center">
            <input type="checkbox" :name="`answerCheckbox-${question.id}-other`"
                   @change="e => chooseOtherAnswer(question, e.target.checked)"
                   :id="`answerCheckbox-${question.id}-other`" class="flex-shrink-0"
                   :checked="selected">
            <label :for="`answerCheckbox-${question.id}-other`" class="flex-shrink-0">
                {{ trans('other') }}
            </label>
            <input type="text" class="other-option form-control ml-2" :id="`answerCheckbox-${question.id}-other-input`"
                   @input="e => writeOtherAnswer(e.target.value, question)" :value="title">
        </div>

        <div v-if="question.type === 'radio'" class="d-flex align-items-center">
            <input type="radio" :name="`answerRadio-${question.id}`" :id="`answerRadio-${question.id}-other`"
                   @change="e => chooseOtherAnswer(question, e.target.checked)" class="flex-shrink-0"
                   :checked="selected">
            <label :for="`answerRadio-${question.id}-other`" class="flex-shrink-0">
                {{ trans('other') }}
            </label>
            <input type="text" class="other-option form-control ml-2" :id="`answerRadio-${question.id}-other-input`"
                   @input="e => writeOtherAnswer(e.target.value, question)" :value="title">
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
    name: "OtherAnswer",
    props: ['question', 'selected', 'title'],
    methods: {
        ...mapMutations(['changeOtherUserAnswer']),

        chooseOtherAnswer(question, value = true) {
            let prefix = question.type === 'multiple' ? 'answerCheckbox' : 'answerRadio';
            const input = document.getElementById(`${prefix}-${this.question.id}-other-input`);

            this.$store.commit('changeOtherUserAnswer', {question, answerText: input.value, add: value})
        },

        writeOtherAnswer(answerText, question) {
            let prefix = question.type === 'multiple' ? 'answerCheckbox' : 'answerRadio';
            const option = document.getElementById(`${prefix}-${this.question.id}-other`);
            option.checked = true;

            this.$store.commit('changeOtherUserAnswer', {answerText, question, add: true})
        },
    },
    computed: {
        classes() {
            let classes = [];

            switch (this.question.type) {
                case 'radio':
                    classes.push('custom-radio-glogal');
                    break;
                case 'multiple':
                    classes.push('custom-checkbox-glogal');
                    break;
            }

            return classes;
        },

      isIframe() {
          return window.location.href.search('iframe') !== -1;
      }
    }
}
</script>
